module.exports = __webpack_public_path__ + "static/media/p17.8b44ffe0.jpeg";